export const FORM = 'FORM';
// eventos relacionados al persist/update del elemento
export const FORM_SUBMIT_INIT = 'FORM_SUBMIT_INIT';
export const FORM_SUBMIT_ERROR = 'FORM_SUBMIT_ERROR';
export const FORM_SUBMIT_SUCCESS = 'FORM_SUBMIT_SUCCESS';
export const FORM_SUBMIT_TYPES = [
  FORM_SUBMIT_INIT,
  FORM_SUBMIT_SUCCESS,
  FORM_SUBMIT_ERROR
];

// eventos relacionados al la carga del elemento a editar
export const FORM_EDIT_INIT = 'FORM_EDIT_INIT';
export const FORM_EDIT_ERROR = 'FORM_EDIT_ERROR';
export const FORM_EDIT_SUCCESS = 'FORM_EDIT_SUCCESS';
export const FORM_EDIT_TYPES = [
  FORM_EDIT_INIT,
  FORM_EDIT_SUCCESS,
  FORM_EDIT_ERROR
];


// eventos relacionados a la eliminación de un elemento
export const FORM_REMOVE_INIT = 'FORM_REMOVE_INIT';
export const FORM_REMOVE_ERROR = 'FORM_REMOVE_ERROR';
export const FORM_REMOVE_SUCCESS = 'FORM_REMOVE_SUCCESS';
export const FORM_REMOVE_TYPES = [
  FORM_REMOVE_INIT,
  FORM_REMOVE_SUCCESS,
  FORM_REMOVE_ERROR
];



// WEBPACK FOOTER //
// ./src/core/services/form/action-types.js